import * as Mustache from "mustache";
/**
 * Simple wrapper for mustache to streamline imports and feature usage.
 * @param template The template string
 * @param view The view
 */
export function render(template, view) {
    return Mustache.render(template, view);
}
//# sourceMappingURL=render.js.map